import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "70",
  fill: "currentColor",
  viewBox: "0 0 70 70"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M56.34 9.111 28.857 35 56.34 60.889a2.088 2.088 0 0 1 0 3.048l-5.818 5.48a2.152 2.152 0 0 1-2.944 0L12.662 36.525a2.088 2.088 0 0 1 0-3.048L47.577.582a2.152 2.152 0 0 1 2.944 0l5.818 5.481a2.088 2.088 0 0 1 0 3.048Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h70v70H0z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }